/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_Edit_RequiredInputs */

const en_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Required`)
};

const fr_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modification requise`)
};

const de_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeitung erforderlich`)
};

const it_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica richiesta`)
};

const ru_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуется редактирование`)
};

const es_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edición requerida`)
};

const zh_cn2_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要编辑`)
};

const ja_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集が必要です`)
};

const hi_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादन आवश्यक है`)
};

const pt_pt2_work_order_publish_option_edit_required = /** @type {(inputs: Work_Order_Publish_Option_Edit_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É necessário editar.`)
};

/**
* | output |
* | --- |
* | "Edit Required" |
*
* @param {Work_Order_Publish_Option_Edit_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_edit_required = /** @type {((inputs?: Work_Order_Publish_Option_Edit_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_Edit_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_option_edit_required(inputs)
	if (locale === "de") return de_work_order_publish_option_edit_required(inputs)
	if (locale === "it") return it_work_order_publish_option_edit_required(inputs)
	if (locale === "ru") return ru_work_order_publish_option_edit_required(inputs)
	if (locale === "es") return es_work_order_publish_option_edit_required(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_option_edit_required(inputs)
	if (locale === "ja") return ja_work_order_publish_option_edit_required(inputs)
	if (locale === "hi") return hi_work_order_publish_option_edit_required(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_option_edit_required(inputs)
	return en_work_order_publish_option_edit_required(inputs)
});